const locale = [
  {
    code: "es",
    label: "Español",
    iso2: "CO",
    id: "es_CO"
  },
  {
    code: "en",
    label: "Inglés",
    iso2: "CO",
    id: "en_CO"
  },
  {
    code: "en",
    label: "English",
    iso2: "US",
    id: "en_US"
  },
  {
    code: "es",
    label: "Spanish",
    iso2: "US",
    id: "es_US"
  }
]
export default locale
